import type { Field } from '../api/Field';
import type { Filter } from '../api/Filter';
import type { FilterEvaluator } from '../api/FilterEvaluator';
import { MatchAllEvaluator } from '../api/MatchAllEvaluator';
import { LeafFilterBuilder } from './LeafFilterBuilder';
import { StartsWithEvaluator } from './StartsWithFilterBuilder';

export class NotStartsWithFilterBuilder extends LeafFilterBuilder {
  protected _buildEvaluator<RecordType>(
    filter: Filter,
    field: Field<RecordType>,
    values: object[],
  ): FilterEvaluator<RecordType> {
    if (values.length === 0) {
      return MatchAllEvaluator.INSTANCE as FilterEvaluator<RecordType>;
    }
    const comparableValues = this.toComparableValues(field, values);

    return new NotStartsWithEvaluator(field, comparableValues[0]);
  }
}

class NotStartsWithEvaluator<RecordType> extends StartsWithEvaluator<RecordType> {
  public evaluate(record: RecordType): boolean {
    return !super.evaluate(record);
  }
}
